'use client';

import React from 'react';

export default function Footer() {
  const scrollToSection = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-dark border-t" style={{ borderColor: 'rgba(255,255,255,0.08)' }}>
      {/* Main footer content */}
      <div className="max-w-7xl mx-auto px-5 md:px-16 lg:px-24 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          {/* Brand column */}
          <div className="md:col-span-4">
            <button
              onClick={() => scrollToSection('hero')}
              className="font-condensed font-bold text-3xl tracking-widest uppercase text-light-warm hover:text-primary transition-colors duration-300 mb-4 block"
            >
              RAMSON
            </button>
            <p
              className="font-serif text-secondary-dark leading-relaxed mb-6"
              style={{ fontSize: '0.95rem', fontStyle: 'italic', opacity: 0.7 }}
            >
              Digital Marketing & Communications Specialist based in Belgium.
              Combining data, content, and strategy.
            </p>
            <div className="flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-accent-green" />
              <span className="font-condensed text-xs tracking-widest uppercase text-secondary-dark opacity-50">
                Available for opportunities
              </span>
            </div>
          </div>

          {/* Navigation */}
          <div className="md:col-span-3 md:col-start-6">
            <p className="font-condensed font-bold text-xs tracking-widest uppercase text-secondary-dark opacity-40 mb-6">
              Navigation
            </p>
            <nav className="space-y-3">
              {[
                { id: 'about', label: 'About Me' },
                { id: 'skills', label: 'Skills & Tools' },
                { id: 'projects', label: 'Projects' },
                { id: 'services', label: 'Services' },
                { id: 'contact', label: 'Contact' },
              ].map((link) => (
                <button
                  key={link.id}
                  onClick={() => scrollToSection(link.id)}
                  className="block font-condensed font-bold text-sm tracking-wider uppercase text-secondary-dark hover:text-primary transition-colors duration-300"
                >
                  {link.label}
                </button>
              ))}
            </nav>
          </div>

          {/* Contact */}
          <div className="md:col-span-3 md:col-start-10">
            <p className="font-condensed font-bold text-xs tracking-widest uppercase text-secondary-dark opacity-40 mb-6">
              Get In Touch
            </p>
            <div className="space-y-3">
              <a
                href="mailto:ramsonndanjim@hotmail.com"
                className="block font-sans text-sm text-secondary-dark hover:text-primary transition-colors duration-300"
                style={{ opacity: 0.75 }}
              >
                ramsonndanjim@hotmail.com
              </a>
              <a
                href="tel:+32484616927"
                className="block font-sans text-sm text-secondary-dark hover:text-primary transition-colors duration-300"
                style={{ opacity: 0.75 }}
              >
                +32 484 61 69 27
              </a>
              <a
                href="https://www.linkedin.com/in/ramson-ndanjim"
                target="_blank"
                rel="noopener noreferrer"
                className="block font-sans text-sm text-secondary-dark hover:text-primary transition-colors duration-300"
                style={{ opacity: 0.75 }}
              >
                LinkedIn
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div
        className="border-t px-5 md:px-16 lg:px-24 py-6"
        style={{ borderColor: 'rgba(255,255,255,0.08)' }}
      >
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
          <p
            className="font-condensed text-xs tracking-wider uppercase text-secondary-dark"
            style={{ opacity: 0.35 }}
          >
            &copy; {currentYear} Ramson Ndanjim. All rights reserved.
          </p>
          <p
            className="font-condensed text-xs tracking-wider uppercase text-secondary-dark"
            style={{ opacity: 0.35 }}
          >
            Digital Marketing & Communications — Belgium
          </p>
        </div>
      </div>
    </footer>
  );
}
